import { Component, Inject, Input, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxUiLoaderService } from "ngx-ui-loader";
import Swal from "sweetalert2";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { encrypt, decrypt } from 'src/app/services/crypto-js.service';
import { CarruselService } from "src/app/services/carrusel.service";

@Component({
  selector: 'app-generate-report',
  templateUrl: './generate-report.component.html',
  styleUrls: ['./generate-report.component.scss']
})
export class GenerateReportComponent implements OnInit {
  formReport: FormGroup;
  minfechaFin: any = "";
  idUserLogged: number;
  error: string = "";
  hasError: boolean = false;
  idBanner: number = 0

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<GenerateReportComponent>,
    private sendReportR: CarruselService,
    private ngxService: NgxUiLoaderService) {
      dialogRef.disableClose = true;
  }

  ngOnInit(): void { 
    this.error = "";

    this.formReport = this.formBuilder.group({
      correo: ["", [Validators.required, Validators.email]],
    });

    this.idBanner = (this.data.hasOwnProperty("idBanner")) ? this.data.idBanner : 0; 
  }

  checkRegex(e){
    if(this.validateEmail(e)){
      this.hasError = false;
      console.log("true")
    }else{
      this.hasError = true;
      console.log("false")
    }
  }

  validateEmail(email) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }

  async send(modalId: any) {
    try {
      let correos: any = []
      correos.push(this.formReport.value.correo)
      const { value } = this.formReport;
      let request: any = []
      request[0] = value.correo
      let object = {
        data:{
          idBanner: this.idBanner,
          destinatarios: correos
        }
      }
  
      if(this.validateEmail(value.correo)) {
        this.ngxService.start();
        this.hasError = false;
        let dataEncode: any
        let dataResponse: any
        let decode: any
  
        dataEncode = await encrypt(object);
        dataResponse = await this.sendReportR.sendReport({ data: dataEncode.data });
        decode = await decrypt(dataResponse);

        if (decode.data.code === 200) {
          this.modalService.open(modalId);
          this.error = "";
          this.onClose();

        } else {
          this.error = decode.body.data.message.short_description;
          this.ngxService.stop();
          return this.showAlert('Error al obtener información', `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`)
        }
      }
      else {
        this.hasError = true;
        console.log("Error")
      }
      this.ngxService.stop();
      
    } catch (error) {
      this.ngxService.stop();
      return this.showAlert('Error en el envío', `Lo sentimos, hubo un problema en el servicio, favor de intentar más tarde.`)
    }
  }

  showAlert(title:string ,message:string){
    Swal.fire({
      title: title,
      icon:  'info',
      text:  message,
      confirmButtonColor: '#545D6E',
      confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
    })
  }

  async sendDetail() {
    console.log('Correo de detalles enviado')
  }

  onClose(): void {
    this.dialogRef.close();
  }

  
}
